__webpack_require__.p = "https://just-scan.gd.ro/scan/";